import React from 'react';
import './style.css';

const PdfLoading = ({ progress = 0 }) => {
  const clamped = Math.max(0, Math.min(100, progress));
  const showIndeterminate = clamped === 0;

  return (
    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000', color: '#fff' }}>
      <div style={{ width: 280, maxWidth: '90%', padding: 16, borderRadius: 12, background: 'rgba(255,255,255,0.03)', boxShadow: '0 6px 18px rgba(0,0,0,0.6)', textAlign: 'left' }}>
        <div style={{ fontWeight: 700, letterSpacing: 0.2, color: '#fff', marginBottom: 8 }}>Loading magazine</div>
        <div style={{ height: 8, background: 'rgba(255,255,255,0.08)', borderRadius: 8, overflow: 'hidden' }}>
          <div
            style={{
              height: '100%',
              width: showIndeterminate ? '40%' : `${clamped}%`,
              background: '#2a7398ff',
              transition: showIndeterminate ? 'none' : 'width 300ms ease',
              borderRadius: 8,
              boxShadow: '0 1px 6px rgba(0,0,0,0.2)'
            }}
            className={showIndeterminate ? 'indeterminate' : ''}
          />
        </div>
        <div style={{ marginTop: 8, color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>{showIndeterminate ? 'Preparing…' : `${clamped}%`}</div>
      </div>
    </div>
  );
};

export default PdfLoading;
